export const messages = {
  en: {
    adminRoomFee: {
      id: 'ID',
      roomNumPlaceholder: 'Room number, e.g. 1-1-1123',
      ownerNamePlaceholder: 'Please enter owner name',
      roomFee: 'Room Fee',
      paymentHistory: 'Payment History',
      room: 'Room',
      owner: 'Owner',
      callable: 'Callable',
      receipt: 'Receipt',
      meterReading: 'Meter Reading',
      prepaidAccount: 'Prepaid Account',
      prepaidReceipt: 'Prepaid Receipt',
      deposit: 'Deposit',
      feeName: 'Fee Name',
      payerObj: 'Payer Object',
      cycles: 'Cycles(Month)',
      amount: 'Receivable/Received(¥)',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      roomNum: 'Room Number',
      floor: 'Floor',
      type: 'Type',
      area: 'Built/Indoor Area',
      rent: 'Rent',
      validity: 'Validity',
      roomStatus: 'Room Status',
      roomOweFee: 'Room Owe Fee',
      detail: 'Detail',
      ownerFace: 'Owner Face',
      name: 'Name',
      gender: 'Gender',
      idCard: 'ID Card',
      address: 'Address',
      roomCount: 'Rooms',
      memberCount: 'Members',
      carCount: 'Cars',
      complaintCount: 'Complaints',
      repairCount: 'Repairs',
      oweFee: 'Owe Fee',
      contractCount: 'Contracts',
      meterType: 'Meter Type',
      objName: 'Object Name',
      preDegrees: 'Previous Degrees',
      curDegrees: 'Current Degrees',
      preReadingTime: 'Previous Reading Time',
      curReadingTime: 'Current Reading Time',
      createTime: 'Create Time',
      feeType: 'Fee Type',
      totalAmount: 'Total Amount',
      receiptId: 'Receipt ID',
      accountId: 'Account ID',
      accountName: 'Account Name',
      phone: 'Phone',
      accountType: 'Account Type',
      accountAmount: 'Account Amount',
      accountDetail: 'Account Detail',
      prepaidAmount: 'Prepaid Amount',
      callableAmount: 'Callable Amount',
      owePeriod: 'Owe Period',
      callableMethod: 'Callable Method',
      callablePerson: 'Callable Person',
      refund: 'Refund',
      accountDeduction: 'Account Deduction',
      feeFlag: 'Fee Flag',
      receivableAmount: 'Receivable Amount',
      accountTime: 'Account Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      operation: 'Operation',
      previousDegrees: 'Previous Degrees',
      currentDegrees: 'Current Degrees',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      fixedFee: 'Fixed Fee',
      algorithm: 'Algorithm',
      usage: 'Usage',
      note1: 'Note: "-" in receivable end time means not yet receivable or fee collection ended',
      note2: 'Receivable amount -1 usually means formula setting error, please check',
      oweSubtotal: 'Owe Subtotal',
      male: 'Male',
      female: 'Female',
      yuan: '¥'
    }
  },
  zh: {
    adminRoomFee: {
      id:'编号',
      roomNumPlaceholder: '房屋编号,如1-1-1123',
      ownerNamePlaceholder: '请填写业主名称',
      roomFee: '房屋费用',
      paymentHistory: '缴费历史',
      room: '房屋',
      owner: '业主',
      callable: '催缴',
      receipt: '收据',
      meterReading: '抄表记录',
      prepaidAccount: '预存账户',
      prepaidReceipt: '预存补打',
      deposit: '押金',
      feeName: '费用项目',
      payerObj: '收费对象',
      cycles: '周期(单位:月)',
      amount: '应收/实收(单位:元)',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      roomNum: '房屋编号',
      floor: '楼层',
      type: '类型',
      area: '建筑/室内面积',
      rent: '租金',
      validity: '有效期',
      roomStatus: '房屋状态',
      roomOweFee: '房屋欠费',
      detail: '详情',
      ownerFace: '业主人脸',
      name: '姓名',
      gender: '性别',
      idCard: '身份证',
      address: '家庭住址',
      roomCount: '房屋数',
      memberCount: '业主成员',
      carCount: '车辆数',
      complaintCount: '投诉',
      repairCount: '欠费',
      contractCount: '合同',
      meterType: '表类型',
      objName: '对象名称',
      preDegrees: '上期度数',
      curDegrees: '本期度数',
      preReadingTime: '上期读表时间',
      curReadingTime: '本期读表时间',
      createTime: '创建时间',
      feeType: '费用类型',
      totalAmount: '总金额',
      receiptId: '收据ID',
      accountId: '账户编号',
      accountName: '账户名称',
      phone: '手机号',
      accountType: '账户类型',
      accountAmount: '账户金额',
      accountDetail: '账户明细',
      prepaidAmount: '预存金额',
      callableAmount: '催缴金额',
      owePeriod: '欠费时间段',
      callableMethod: '催缴方式',
      callablePerson: '催缴人',
      refund: '退款',
      accountDeduction: '账户扣款',
      feeFlag: '费用标识',
      receivableAmount: '应收金额',
      accountTime: '建账时间',
      receivablePeriod: '应收时间段',
      description: '说明',
      operation: '操作',
      previousDegrees: '上期度数',
      currentDegrees: '本期度数',
      unitPrice: '单价',
      additionalFee: '附加费',
      fixedFee: '固定费',
      algorithm: '算法',
      usage: '用量',
      note1: '注意：应收结束时间 "-" 表示未到应收时间 或 收费已结束',
      note2: '应收金额为-1 一般为费用项公式设置出错请检查',
      oweSubtotal: '欠费小计',
      male: '男',
      female: '女',
      yuan: '元'
    }
  },
  'zh-TW': {
    adminRoomFee: {
      id: '編號',
      roomNumPlaceholder: '房屋編號,如1-1-1123',
      ownerNamePlaceholder: '請填寫業主名稱',
      roomFee: '房屋費用',
      paymentHistory: '繳費歷史',
      room: '房屋',
      owner: '業主',
      callable: '催繳',
      receipt: '收據',
      meterReading: '抄表記錄',
      prepaidAccount: '預存帳戶',
      prepaidReceipt: '預存補打',
      deposit: '押金',
      feeName: '費用項目',
      payerObj: '收費對象',
      cycles: '週期(單位:月)',
      amount: '應收/實收(單位:元)',
      paymentMethod: '繳費方式',
      paymentPeriod: '繳費起始段',
      paymentTime: '繳費時間',
      cashier: '收銀員',
      status: '狀態',
      remark: '備註',
      roomNum: '房屋編號',
      floor: '樓層',
      type: '類型',
      area: '建築/室內面積',
      rent: '租金',
      validity: '有效期',
      roomStatus: '房屋狀態',
      roomOweFee: '房屋欠費',
      detail: '詳情',
      ownerFace: '業主人臉',
      name: '姓名',
      gender: '性別',
      idCard: '身份證',
      address: '家庭住址',
      roomCount: '房屋數',
      memberCount: '業主成員',
      carCount: '車輛數',
      complaintCount: '投訴',
      repairCount: '欠費',
      contractCount: '合同',
      meterType: '表類型',
      objName: '對象名稱',
      preDegrees: '上期度數',
      curDegrees: '本期度數',
      preReadingTime: '上期讀表時間',
      curReadingTime: '本期讀表時間',
      createTime: '創建時間',
      feeType: '費用類型',
      totalAmount: '總金額',
      receiptId: '收據ID',
      accountId: '帳戶編號',
      accountName: '帳戶名稱',
      phone: '手機號',
      accountType: '帳戶類型',
      accountAmount: '帳戶金額',
      accountDetail: '帳戶明細',
      prepaidAmount: '預存金額',
      callableAmount: '催繳金額',
      owePeriod: '欠費時間段',
      callableMethod: '催繳方式',
      callablePerson: '催繳人',
      refund: '退款',
      accountDeduction: '帳戶扣款',
      feeFlag: '費用標識',
      receivableAmount: '應收金額',
      accountTime: '建帳時間',
      receivablePeriod: '應收時間段',
      description: '說明',
      operation: '操作',
      previousDegrees: '上期度數',
      currentDegrees: '本期度數',
      unitPrice: '單價',
      additionalFee: '附加費',
      fixedFee: '固定費',
      algorithm: '演算法',
      usage: '用量',
      note1: '注意：應收結束時間 "-" 表示未到應收時間 或 收費已結束',
      note2: '應收金額為-1 一般為費用項公式設置出錯請檢查',
      oweSubtotal: '欠費小計',
      male: '男',
      female: '女',
      yuan: '元'
    }
  }
}